// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0de64d2e","455":"5270c482"}[chunkId] + ".chunk.js";
};